import "./polyfills.ts";
//import 'zone.js/dist/zone';
//import 'reflect-metadata';
import "web-animations-js"; // Run `npm install --save web-animations-js`.

if ((<any>document)["documentMode"] || /Edge/.test(navigator.userAgent)) {
    (window as any).__Zone_enable_cross_context_check = true;
}
